<template>
    <div id="bg">
        <div class="text">点击免费下载京福APP</div>
        <div class="ios">
            <img @click="holdOn" src="../../assets/image/iphone.png" alt="">
            <img @click="androidDownload" src="../../assets/image/android.png" alt="">
        </div>
        <div class="record" @click="jumpRecord">
            Copyright @2021 京ICP证041356号-4
        </div>
    </div>
</template>
<script>
import {isAndroid} from "../../base/callClient/core/useragent.js";
export default {
    methods: {
        jumpRecord() {
            window.location.href = "https://beian.miit.gov.cn/";
        },
        androidDownload() {
            if (isAndroid()) {
                top.location.href =
                    "http://dl.yftepay.com/jingfu/apk/jf_1.0.15.apk";
            } else {
                alert("请点击iPhone下载链接");
            }
        },
        holdOn() {
            if (!isAndroid()) {
                top.location.href =
                    "https://apps.apple.com/cn/app/%E4%BA%AC%E7%A6%8F/id1521120679";
            } else {
                alert("请点击Android下载链接");
            }
        }
    }
};
</script>
<style lang="scss">
#bg {
    width: 100%;
    height: 100vh;
    background: url(../../assets/image/wapDownload.png);
    background-size: cover;
    overflow: hidden;
    position: relative;
    .text {
        position: absolute;
        bottom: 140px;
        // margin-top: 112%;
        left: 0;
        right: 0;
        font-size: 18px;
        color: white;
        line-height: 48px;
        height: 48px;
    }
    .ios {
        width: 100%;
        // margin-left: 50%;
        // transform: translateX(-50%);
        text-align: center;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 80px;
        img {
            width: 140px;
            height: 45px;
            &:last-of-type {
                margin-left: 25px;
            }
        }
    }
    .record {
        position: fixed;
        bottom: 4px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.3);
        left: 0;
        right: 0;
    }
}
</style>